import { render, staticRenderFns } from "./TestStatisticsTab.vue?vue&type=template&id=12a82909&scoped=true&"
import script from "./TestStatisticsTab.vue?vue&type=script&lang=js&"
export * from "./TestStatisticsTab.vue?vue&type=script&lang=js&"
import style0 from "./TestStatisticsTab.vue?vue&type=style&index=0&id=12a82909&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a82909",
  null
  
)

export default component.exports